import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const RFCInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="RFC">
      {getFieldDecorator("RFC", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el RFC."
          }
        ],
        initialValue: implementerProfile?.RFC
      })(
        <Input
          disabled={isBusy}
          id="RFC"
          name="RFC"
          placeholder="RFC"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
